import { NextEnvVarProps } from "@/utils/getServerSideProps";
import { NextEnvVars, getNextEnvVarFallbacks } from "@/utils/hooks/get-next-env-vars";
import React, { PropsWithChildren, useContext } from "react";

export const NextEnvVarsContext = React.createContext<NextEnvVars | undefined>(undefined);

export const NextEnvVarsWrapper: React.FC<PropsWithChildren<NextEnvVarProps>> = ({
  envVars,
  children,
}) => {
  return <NextEnvVarsContext.Provider value={envVars}>{children}</NextEnvVarsContext.Provider>;
};

export function useNextEnvVars(): NextEnvVars {
  return getNextEnvVarFallbacks(useContext(NextEnvVarsContext));
}
